import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import Slider from 'react-input-slider';
import Button from './Button';
//import { attachPretendOpacity } from '../modules/attachPretendOpacity';
// import InputRange from 'react-input-range';

function SettingsMenu({
    toggleMenu,
    setSilenceSeconds,
    silenceSeconds,
    manualContinueButton,
    setOnManualContinueButton,
    setOffManualContinueButton,
}) {
    const [state, setState] = useState({
        x: silenceSeconds,
        fullManual: false,
    });
    // const [fullManual, setFullManual] = useState({ fullManual: false });

    return (
        <div className="settings-menu slide-up">
            <div/>
            <div style={{ display: 'grid',  }}>
                <h2 style={{ textAlign: 'center'}}>Settings</h2>
                <div>
                    
                    <div>
                        <div className="silence-detect-buttons" style={{fontSize:'1em'}}>
                            {/* Set silence to 3 mins */}
                            <Button
                                label="Default"
                                isInactive={
                                    !manualContinueButton || state.fullManual
                                }
                                onClick={function() {
                                    setOnManualContinueButton();
                                    if (state.fullManual) {
                                        setState({
                                            x: parseFloat(3),
                                            fullManual: false,
                                        });
                                    }
                                }}
                                width={'10em'}
                            />
                            {/* Set silence to 3 sec */}
                            <Button
                                label="Manual Buttons"
                                width={'10em'}
                                isInactive={!state.fullManual}
                                onClick={function() {
                                    setState({
                                        x: parseFloat(180).toFixed(2),
                                        fullManual: true,
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <p style={{ 
                    color: 'white', 
                    textAlign: 'center', 
                    fontSize: '0.9em', 
                    padding: '5px 25px 7px',
                    marginBottom: '-5px', 
            }}>
                        If you're in a noisy environment, use manual buttons
                    </p>
                </div>
                <div>
                    <div
                        style={{
                            display: 'grid',
                            justifyContent: 'center',
                            alignItems: 'end',
                            color: 'white',
                            marginBottom: '20px',
                            marginTop: '10px',
                            fontSize: '0.9em',
                            padding: '10px 5px 7px',
                            textAlignLast: 'center',
                        }}
                    >
                        {state.fullManual
                            ? 'Silence detection disabled'
                            : 'Toggle slider (1 if you speak fast, 5 if you speak slow): ' 
                             + 
                             state.x
                            }
                    </div>
                    <div
                        style={{
                            display: 'grid',
                            justifyContent: 'center',
                            height: '3e',
                        }}
                    >
                        {state.fullManual === false && (
                            <Slider
                                axis="x"
                                xstep={1}
                                xmin={1}
                                xmax={5}
                                x={state.x}
                                onChange={({ x }) => {
                                    setState({
                                        x: parseFloat(x.toFixed(2)),
                                        fullManual: false,
                                    });
                                }}
                                styles={{
                                    active: {
                                        backgroundColor: 'rgba(0,0,0,0.6)',
                                    },
                                }}
                            />
                        )}
                    </div>
                </div>
                
                <div style={{ alignSelf: 'end' }}>
                    {/* <p style={{ color: 'white', textAlign: 'center' }}>
                        You can toggle the amount of silence the system expects
                        - or just turn on the manual controls for complete
                        control.
                    </p> */}
                </div>
            </div>

            <div>
                <FontAwesomeIcon
                    icon={faAngleDown}
                    style={{ marginTop: '20px' }}
                    onClick={() => {
                        toggleMenu();
                        setSilenceSeconds(state.x);
                    }}
                />
            </div>
        </div>
    );
}

export default SettingsMenu;
